export default function priceFormatter(price: string | number) {
    const parsedPrice = parseFloat(price.toString());
    const number = (Number.isFinite(parsedPrice) ? parsedPrice : 0).toFixed(2);
    const parts = number.split('.');
    const integerPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    const decimalPart = (parts[1] ?? '00').padEnd(2, '0');
    const formattedNumber = `${integerPart}.${decimalPart}`;

    return formattedNumber;
}
